import axios from 'axios'
import { resourceTokenGenerate, resourcerFileUpload, getTemplateData, saveCanvasDpi, getCanvasDpi, getFontList, getUserResourcePages, saveFont, searchbyimage } from '@/api/design/resource'
import { saveCanvasData } from '@/api/affairs'

import { useSdkStore } from "@/stores/sdk";
import { useTagListStore } from "@/stores/tag";
import { useMiscStore } from "@/stores/misc";
import { ElMessage, ElMessageBox, ElSelect, ElOption, ElForm, ElFormItem, ElInput, ElInputNumber } from 'element-plus'
import { h, ref, defineComponent, render } from 'vue'

export const saveTemplate = async (data: any) => {
    console.log('data:', data)
    let webpUrl
    let jsonUrl
    const modifyPreview = async (pk: number) => {
        const res = await resourceTokenGenerate({ pk, ext: 'webp', filename: 'asfasfasfas' })
        if (res.data.code === 200 && data.preview) {
            console.log('res.data.data:', data.preview)
            const token = res.data.data.token
            const contentType = res.data.data.content_type
            webpUrl = token.replace(/\?.*$/, '')
            await axios.put(token, data.preview, { headers: { 'Content-Type': contentType } })
        }
    }
    const modifyTemplate = async (pk: number) => {
        const res = await resourceTokenGenerate({ pk, ext: 'json', filename: 'asfasfasfas' })
        if (res.data.code === 200) {
            const token = res.data.data.token
            console.log('token:', token)
            const contentType = res.data.data.content_type
            jsonUrl = token.replace(/\?.*$/, '')
            await axios.put(token, data.templates, { headers: { 'Content-Type': contentType } })
        }
    }
    const urlParams = new URLSearchParams(window.location.search)
    if (!urlParams.get('id')) {
        return
    }
    const pk = urlParams.get('id') as string
    if (data.preview && data.templates) {
        await modifyPreview(data.pk || pk)
        await modifyTemplate(data.pk || pk)
    }
    let params = {
        id: data.pk || pk,
        template_json: jsonUrl,
        preview: webpUrl,
        canvas_id: data.currentTemplate.id,
        total_canvas_ids: data.templates.map((item: any) => item.id).join(',')
    }
    if (!urlParams.get('order_no')) {
        saveCanvasData(params)
    }


}
// {
//     "id": "16198",
//         "template_json": "https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/resource/template/user/1_16198_3g3zazslpbddsakvlhbp9u1hgojkt8pg.json",
//             "preview": "https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/resource/template/user/1_16198_3g3zazslpbddsakvlhbp9u1hgojkt8pg.webp",
//                 "canvas_id": "uO60hFtiVz",
//                     "total_canvas_ids": "uO60hFtiVz,gA46ATdS-R"
// }
export const uploadfile = async (data: any) => {
    console.log('data:', data)
    const res = await resourcerFileUpload(data.file)
    if (res.data.code === 200) {
        return res.data.data
    }

}


export const loadTemplate = async () => {
    const urlParams = new URLSearchParams(window.location.search)
    const query = Object.fromEntries(urlParams.entries())
    console.log('URL query parameters:', query)
    const param = {
        pk: query.id,
        template: query.template,
        mode: query.mode
    }
    let result = await getTemplateData(param)

    const ossURL = result.data.data.data
    const miscStore = useMiscStore()
    miscStore.setOssURL(ossURL)
    const response = await axios.get(ossURL, { headers: { 'Cache-Control': 'no-cache' } })
    let getdpi = await getCanvasDpi({ canvas_id: response.data[0].id, template_id: query.id })
    const sdkStore = useSdkStore();
    const sdk = sdkStore.getSdk()
    const dpiVal = getdpi?.data?.data?.dpi
    console.log('dpiVal:', sdk)
    sdk.designOpt.setDpi(dpiVal)
    currentCanvasId = response.data[0].id
    currentTemplateId = query.id
    loadTag(result.data.data.customize_tags)
    return result.data.data
}
const loadTag = async (tags: any) => {
    try {
        const tagListStore = useTagListStore()
        const response = await axios.get(tags, { headers: { 'Cache-Control': 'no-cache' } })
        let taglist = response.data
        if (taglist && taglist.length) {
            // 清空所有打标数据
            tagListStore.clearAllTags();
            // 赋值打标数据
            taglist.forEach((item: any) => {
                tagListStore.addTagList(item.id, item.taglist);
            })
        }
    } catch (error) {

    }

}

let currentCanvasId: number | null = null
let currentTemplateId: any = null
export const onDpiChange = async (dpi: number) => {
    if (currentCanvasId && currentTemplateId) {
        await saveCanvasDpi({ canvas_id: currentCanvasId, template_id: currentTemplateId, dpi })
    }
}
export const opentagdialog = () => {
    const sdkStore = useSdkStore();
    const tagListStore = useTagListStore()
    let currentTemplate = sdkStore.getSdk().designOpt.getTemplate().currentTemplate.value
    let activeObject = sdkStore.getSdk().designOpt.getSelectedElement().activeObject
    const tagType = ref('text')
    const tagField = ref('')
    const tagMaxLength = ref<number | undefined>(undefined)
    const tagContent = ref('')
    const tagRemarks = ref('')
    if (activeObject) {
        tagType.value = activeObject.type == 'image' ? 'image' : 'text'
    }
    let tagDetail = tagListStore.getTagDetail(currentTemplate.id, activeObject.id)
    console.log('tagDetail:', tagDetail)
    if (tagDetail) {
        tagType.value = tagDetail.type
        tagField.value = tagDetail.desc
        tagMaxLength.value = tagDetail.max_length
        tagContent.value = tagDetail.demo_value
        tagRemarks.value = tagDetail.remarks
    }

    const TagForm = defineComponent({
        name: 'TagForm',
        setup() {
            return () => h(
                'div',
                { style: 'width: 100%' },
                [
                    h(
                        ElForm,
                        { labelWidth: '100px', class: 'w-full' },
                        () => {
                            const isImage = activeObject && String(activeObject.type).toLowerCase() === 'image'
                            const items: any[] = []
                            items.push(
                                h(
                                    ElFormItem,
                                    { label: '标记类型', class: 'w-full' },
                                    () => [
                                        h(
                                            ElSelect,
                                            {
                                                modelValue: tagType.value,
                                                'onUpdate:modelValue': (val: string) => (tagType.value = val),
                                                placeholder: '请选择标记类型',
                                                disabled: true,
                                                class: 'w-full',
                                                style: 'width: 100%'
                                            },
                                            () => [
                                                h(ElOption, { label: '文字', value: 'text' }),
                                                h(ElOption, { label: '图片', value: 'image' })
                                            ]
                                        )
                                    ]
                                )
                            )
                            items.push(
                                h(ElFormItem, { label: '字段名', class: 'w-full' }, () => [
                                    h(ElInput, {
                                        modelValue: tagField.value,
                                        'onUpdate:modelValue': (val: string) => (tagField.value = val),
                                        placeholder: '请输入字段名',
                                        class: 'w-full',
                                        style: 'width: 100%'
                                    })
                                ])
                            )
                            if (!isImage) {
                                items.push(
                                    h(ElFormItem, { label: '文本最大长度', class: 'w-full' }, () => [
                                        h(ElInputNumber, {
                                            modelValue: tagMaxLength.value,
                                            'onUpdate:modelValue': (val: number | undefined) => (tagMaxLength.value = val),
                                            placeholder: '请输入文本最大长度',
                                            class: 'w-full',
                                            style: 'width: 100%'
                                        })
                                    ])
                                )
                                items.push(
                                    h(ElFormItem, { label: '标记内容', class: 'w-full' }, () => [
                                        h(ElInput, {
                                            modelValue: tagContent.value,
                                            'onUpdate:modelValue': (val: string) => (tagContent.value = val),
                                            placeholder: '请输入标记内容',
                                            class: 'w-full',
                                            style: 'width: 100%',
                                            maxlength: tagMaxLength.value,
                                            showWordLimit: true,
                                            clearable: true
                                        })
                                    ])
                                )
                            }
                            items.push(
                                h(ElFormItem, { label: '标记备注', class: 'w-full' }, () => [
                                    h(ElInput, {
                                        modelValue: tagRemarks.value,
                                        'onUpdate:modelValue': (val: string) => (tagRemarks.value = val),
                                        placeholder: '请输入标记备注',
                                        class: 'w-full',
                                        style: 'width: 100%',
                                        showWordLimit: true,
                                        clearable: true
                                    })
                                ])
                            )
                            return items
                        }
                    )
                ]
            )
        }
    })
    ElMessageBox({
        title: '标记信息',
        message: h(TagForm),
        showCancelButton: true,
        confirmButtonText: '保存标记内容',
        cancelButtonText: '取消'
    }).then(async () => {
        if (!!tagDetail) {
            tagListStore.updateTag(currentTemplate.id, activeObject.id, {
                type: tagType.value,
                desc: tagField.value,
                max_length: tagMaxLength.value,
                demo_value: tagContent.value,
                remarks: tagRemarks.value,
                imgae_type: tagType.value === 'image' ? 'png' : '',
            })
        } else {
            let arr = {
                unique_id: activeObject.id,
                type: tagType.value,
                desc: tagField.value,
                max_length: tagMaxLength.value || 0,
                min_length: 1,
                imgae_type: tagType.value === 'image' ? 'png' : '',
                demo_value: tagContent.value,
                remarks: tagRemarks.value,
            }
            tagListStore.addTagToCanvas(currentTemplate.id, arr)
        }
        try {
            const urlParams = new URLSearchParams(window.location.search)
            const pk = urlParams.get('id') as string
            const res = await resourceTokenGenerate({ pk: pk as string, ext: 'tags', filename: 'tagJson' });
            if (res.data.code === 200) {
                const token = res.data.data.token
                await axios.put(token, tagListStore.allTagGroups)
            }
        } catch (error) {
            console.error('上传打标数据错误:', error)
        }
    }).catch(() => {
        // 用户取消，无需处理
    })
}

export const setfontList = async () => {
    let page = 1
    const size = 100
    const all: any[] = []
    while (true) {
        const res = await getFontList({ page, size })
        const items = res?.data?.data?.items || []
        const base = 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com'
        const normalize = (s: any) => {
            const v = String(s || '')
            if (!v) return v
            return v.startsWith('http') ? v : `${base}${v.startsWith('/') ? '' : '/'}${v}`
        }
        for (const it of items) {
            if (it) {
                if ('url' in it) (it as any).url = normalize((it as any).url)
                if ('preview' in it) (it as any).preview = normalize((it as any).preview)
            }
            all.push(it)
        }
        if (items.length < size) break
        page += 1
    }
    const seen = new Set<string>()
    const unique: any[] = []
    for (const it of all) {
        const k = String((it as any).fontname || '').trim().toLowerCase()
        if (!k) {
            unique.push(it)
            continue
        }
        if (seen.has(k)) continue
        seen.add(k)
        unique.push(it)
    }
    const sdkStore = useSdkStore();
    const sdk = sdkStore.getSdk()
    sdk.designOpt.setFontConfig({ fontList: unique })
}
export const uploadFont = async (uploadListFn) => {
    const input = document.createElement('input') as HTMLInputElement
    input.type = 'file'
    input.accept = '.ttf,.otf,.woff,.woff2'
    input.multiple = true
    input.onchange = async () => {
        const files = input.files ? Array.from(input.files) : []
        console.log('files', files)
        await resourcerFileUpload(files[0])
        const fileName = files[0].name.replace(/\.[^/.]+$/, '')
        await addfont(fileName)
        await setfontList()
        uploadListFn()

    }
    input.click()
}
const addfont = async (filename: any) => {
    const res = await getUserResourcePages({ page: 1, size: 10 })
    let list = res.data.data.items
    const fontItem = list.find(item => item.name === filename)
    if (fontItem) {
        const base = 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com'
        const normalize = (s: any) => {
            const v = String(s || '')
            if (!v) return v
            return v.startsWith('http') ? v : `${base}${v.startsWith('/') ? '' : '/'}${v}`
        }
        const fontUrl = normalize(fontItem.url)
        const previewUrl = normalize(fontItem.preview)
        const fontName = fontUrl || fontItem.name
        let params = {
            "url": fontUrl,
            "preview": previewUrl,
            "fontname": fontName,
            "font_family": fontName,
            "resource_id": fontItem.id
        }
        await saveFont(params)
    }


}
export const AIsearchimg = async (e) => {
    const sdkStore = useSdkStore();
    const sdk = sdkStore.getSdk()
    const activeObject = sdk.designOpt.getSelectedElement().activeObject
    console.log('activeObject:', activeObject)
    sdk.designOpt.showLoading(true)
    const res = await searchbyimage({
        image_url: activeObject?.src || activeObject?.originSrc,
        size: 30
    })
    const aiImgs = res?.data?.data?.items || []
    sdk.designOpt.showLoading(false)
    const anchor = e && (e.currentTarget || e.target) as HTMLElement | null
    const container = document.querySelector('#page') as HTMLElement | null
    const mount = document.createElement('div')
    if (container) {
        container.appendChild(mount)
    } else {
        document.body.appendChild(mount)
    }
    let offset = 0
    let lastLeft = 0
    let lastTop = 0
    let rafId = 0
    const close = () => {
        render(null, mount)
        if (mount.parentNode) (mount.parentNode as HTMLElement).removeChild(mount)
        window.removeEventListener('scroll', relayout, true)
        window.removeEventListener('resize', relayout)
        if (container) container.removeEventListener('scroll', relayout)
        if (rafId) cancelAnimationFrame(rafId)
        window.removeEventListener('click', onClickOutside, true)
    }
    const getPreviewSrc = (it: any) => {
        const s = (it && (it.previewUrl || it.preview || it.url || it.image || it.image_url || it.cover_image)) || ''
        return String(s)
    }
    const useImage = (src: string) => {
        sdk.designOpt.replaceImage(src)
    }
    const renderPopup = (layoutOnly: boolean = false) => {
        const rectEl = anchor ? anchor.getBoundingClientRect() : (container ? container.getBoundingClientRect() : { left: 0, top: 0 })
        const left = rectEl.left - 60
        const top = rectEl.top - 140
        const len = aiImgs.length
        const batch = len ? [aiImgs[(offset) % len], aiImgs[(offset + 1) % len], aiImgs[(offset + 2) % len]] : []
        let imageNodes: any[] = []
        if (batch.length) {
            imageNodes = batch.map((it: any) => {
                const src = getPreviewSrc(it)
                return h('div', { style: 'flex:1;height:80px;border-radius:8px;overflow:hidden;background:#f5f5f5;cursor:pointer;', onClick: () => useImage(src) }, [
                    h('img', { src, style: 'width:100%;height:100%;object-fit:cover;object-position:center;display:block;' })
                ])
            })
        } else {
            imageNodes = [h('div', { style: 'position:absolute;left:12px;top:40px;font-size:12px;color:#666;' }, '暂无图片')]
        }
        if (layoutOnly && left === lastLeft && top === lastTop) return
        lastLeft = left
        lastTop = top
        const vnode = h('div', {
            style: `position:fixed;left:${left}px;top:${top + 10}px;width:270px;height:167px;background:#fff;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,.18);z-index:9999;`
        }, [
            h('div', { style: 'position:absolute;left:12px;top:10px;font-size:12px;color:#111;font-weight:600;' }, 'AI搜图结果'),
            h('div', { style: 'position:absolute;right:8px;top:8px;width:24px;height:24px;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#666;', onClick: close }, '×'),
            h('div', { style: 'position:absolute;left:12px;right:12px;top:40px;height:80px;display:flex;gap:8px;' }, imageNodes),
            h('div', { style: 'position:absolute;right:12px;bottom:10px;font-size:12px;color:#2a66ff;cursor:pointer;', onClick: () => { if (len) { offset = (offset + 3) % len; renderPopup(false) } } }, '换一批')
        ])
        render(vnode, mount)
    }
    const relayout = () => renderPopup(true)
    window.addEventListener('scroll', relayout, true)
    window.addEventListener('resize', relayout)
    if (container) container.addEventListener('scroll', relayout)
    const step = () => { renderPopup(true); rafId = requestAnimationFrame(step) }
    rafId = requestAnimationFrame(step)
    const onClickOutside = (evt: MouseEvent) => { const t = evt.target as Node | null; if (t && !mount.contains(t)) close() }
    setTimeout(() => window.addEventListener('click', onClickOutside, true), 0)
}